import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { erpApi, type ErpOverview } from '../../api/erp';
import { StatCard } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { formatCount, formatMoney } from '../../utils/numbers';
import './erp.css';

export function ErpDashboardPage() {
  const [overview, setOverview] = useState<ErpOverview | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    erpApi
      .getOverview()
      .then((res) => setOverview(res.overview))
      .catch((err) => setError(err instanceof Error ? err.message : 'Error al cargar'));
  }, []);

  if (error) return <p style={{ color: 'var(--color-danger)' }}>{error}</p>;
  if (!overview) return <p>Cargando resumen…</p>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
        <h1 style={{ margin: 0 }}>Resumen</h1>
        <Link to="/erp/agentes/nuevo">
          <Button size="sm">Nuevo agente</Button>
        </Link>
      </div>

      <div className="erp-stats">
        <StatCard
          label="Agentes activos"
          value={formatCount(overview.agents.active)}
          hint={`${formatCount(overview.agents.total)} en total`}
        />
        <StatCard
          label="Tickets pendientes"
          value={formatCount(overview.tickets.pending)}
          hint={`${formatCount(overview.tickets.active_tickets)} en curso`}
        />
        <StatCard label="Resueltos (mes)" value={formatCount(overview.tickets.resolved_month)} />
        <StatCard
          label="Ventas (mes)"
          value={formatCount(overview.sales.total_month)}
          hint={`${formatMoney(overview.sales.commission_month)} comisión`}
        />
        <StatCard
          label="Liquidaciones pendientes"
          value={formatCount(overview.payouts_pending)}
          hint={
            overview.payouts_pending > 0
              ? `${formatMoney(overview.payouts_pending_amount)} por pagar`
              : 'Sin liquidaciones creadas'
          }
        />
        <StatCard
          label="Ganancias sin liquidar"
          value={formatMoney(overview.earnings_pending_total)}
          hint={
            overview.agents_with_pending > 0
              ? `${formatCount(overview.agents_with_pending)} agentes con pendientes`
              : 'Todo al día'
          }
        />
        <StatCard
          label="Agentes inactivos"
          value={formatCount(overview.agents.inactive + overview.agents.suspended)}
        />
      </div>

      <p className="muted">
        Gestiona las cuentas de agentes desde{' '}
        <Link to="/erp/agentes">Agentes</Link>, liquida pagos en{' '}
        <Link to="/erp/pagos">Liquidaciones</Link> y atiende chats en{' '}
        <Link to="/staff">/staff</Link>.
      </p>
    </div>
  );
}
